// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portrait-flex {
  margin: 0px;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  width: 100%;
  justify-content: space-evenly;
  padding-top: 3rem;
}

.portrait-flex_left {
  order: 1;
  padding-top: 5%;
  height: 400px;
  text-align: center;
  align-self: center;
}

.portrait-flex_right {
  order: 2;
  padding-top: 5%;
  margin-top: 1rem;
  height: 400px;
  text-align: center;
  align-self: center;
}

.boxed {
  border: 1px solid silver;
  border-radius: 2px;
  padding: 2rem;
  transition: all 0.2s ease-in-out;
}
.boxed:hover {
  transform: scale(1.1);
}
.boxed img {
  border-radius: 50%;
}
.portrait-below_text {
  font-size: 1.4em;
  color: var(--text-color-dark);
  align-self: center;
}

.social-flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

@media only screen and (min-width: 677px) {
  .portrait-flex {
    flex-direction: row;
    flex-flow: row nowrap;
    padding-right: 1rem;
    padding-top: 6rem;
  }
  .portrait-flex_left {
    height: 450px;
  }
  .portrait-flex_right {
    margin-top: 0;
    height: 450px;
  }
  .boxed {
    padding: 4rem;
  }
}
@media only screen and (min-width: 1024px) {
  .portrait-flex_right {
    margin-bottom: 23%;
  }
  .portrait-flex_left {
    margin-bottom: 23%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/portraits.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".portrait-flex {\n  margin: 0px;\n  display: flex;\n  flex-direction: column;\n  background-color: transparent;\n  width: 100%;\n  justify-content: space-evenly;\n  padding-top: 3rem;\n}\n\n.portrait-flex_left {\n  order: 1;\n  padding-top: 5%;\n  height: 400px;\n  text-align: center;\n  align-self: center;\n}\n\n.portrait-flex_right {\n  order: 2;\n  padding-top: 5%;\n  margin-top: 1rem;\n  height: 400px;\n  text-align: center;\n  align-self: center;\n}\n\n.boxed {\n  border: 1px solid silver;\n  border-radius: 2px;\n  padding: 2rem;\n  transition: all 0.2s ease-in-out;\n}\n.boxed:hover {\n  transform: scale(1.1);\n}\n.boxed img {\n  border-radius: 50%;\n}\n.portrait-below_text {\n  font-size: 1.4em;\n  color: var(--text-color-dark);\n  align-self: center;\n}\n\n.social-flex {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n@media only screen and (min-width: 677px) {\n  .portrait-flex {\n    flex-direction: row;\n    flex-flow: row nowrap;\n    padding-right: 1rem;\n    padding-top: 6rem;\n  }\n  .portrait-flex_left {\n    height: 450px;\n  }\n  .portrait-flex_right {\n    margin-top: 0;\n    height: 450px;\n  }\n  .boxed {\n    padding: 4rem;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .portrait-flex_right {\n    margin-bottom: 23%;\n  }\n  .portrait-flex_left {\n    margin-bottom: 23%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
